import { Mesh3D } from './Mesh3D';
import { BoxShape } from './BoxShape';
import { SphereShape } from './SphereShape';
import { CylinderShape } from './CylinderShape';
import { PlaneShape } from './PlaneShape';
import { MultiPlaneShape } from './MultiPlaneShape';
import { TorusShape } from './TorusShape';
import { SceneSettingsData } from '../core/SceneSettingsData';
import { AppSettingsData } from '../core/AppSettingsData';
import { POI } from '../poi/POI';
import { TriangleShape } from './TriangleShape';
import { HexagonShape } from './HexagonShape';
import { GLTFShape } from './GLTFShape';
import { USDZShape } from './USDZShape';
import { getCanonicalShapeName } from './ShapeTypes';
import { QuaderShape } from './QuaderShape';
import { TileShape } from './TileShape';
import { YoutubeShape } from './YoutubeShape';

export type ShapeType = 'cube' | 'sphere' | 'cylinder' | 'plane' | 'multiplane' | 'torus' | 'tile' | 'quader' | 'box' | 'triangle' | 'hexagon' | 'gltf' | 'usdz' | 'youtube' | 'none';

export class ShapeFactory {
    
    static createShape(
        poi: POI, 
        sceneSettings?: SceneSettingsData, 
        appSettings?: AppSettingsData
    ): Mesh3D | null {
        const rawShapeType = poi.poidata.shape.value ?? 'box';
        const shapeType = getCanonicalShapeName(rawShapeType);
        
        //console.log(`🏭 ShapeFactory: Creating shape for POI "${poi.name}"`);
        //console.log(`🏭 ShapeFactory: Raw shape type: "${rawShapeType}"`);
        //console.log(`🏭 ShapeFactory: Canonical shape type: "${shapeType}"`);
        //console.log(`🏭 ShapeFactory: POI URI: ${JSON.stringify(poi.poidata.uri.value)}`);
        

        


        if (shapeType === 'none') {
            ////console.log(`🏭 ShapeFactory: Shape type is 'none', returning null`);
            return null;
        }

        let createdShape: Mesh3D | null = null;

        switch (shapeType) {
            case 'box':
                ////console.log(`🏭 ShapeFactory: Creating BoxShape`);
                createdShape = new BoxShape(poi, sceneSettings, appSettings);
                break;
            case 'roundedBox':
                ////console.log(`🏭 ShapeFactory: Creating QuaderShape (roundedBox)`);
                createdShape = new QuaderShape(poi, sceneSettings, appSettings);
                break;
            case 'quader':
                //console.log(`🏭 ShapeFactory: Creating QuaderShape (flat rectangle)`);
                createdShape = new QuaderShape(poi, sceneSettings, appSettings);
                break;
            case 'tile':
                //console.log(`🚨 [ShapeFactory] Creating TileShape (extruded frame) for POI: ${poi.name}`);
                //console.log(`  🔍 POI shape value: '${poi.poidata.shape.value}'`);
                //console.log(`  🔍 POI URIs: ${JSON.stringify(poi.poidata.uri.value)}`);
                createdShape = new TileShape(poi, sceneSettings, appSettings);
                //console.log(`✅ [ShapeFactory] TileShape created: ${createdShape.constructor.name}`);
                break;
            case 'sphere':
                ////console.log(`🏭 ShapeFactory: Creating SphereShape`);
                createdShape = new SphereShape(poi, sceneSettings, appSettings);
                break;
            case 'cylinder':
                ////console.log(`🏭 ShapeFactory: Creating CylinderShape`);
                createdShape = new CylinderShape(poi, sceneSettings, appSettings);
                break;
            case 'plane':
                ////console.log(`🏭 ShapeFactory: Creating PlaneShape`);
                createdShape = new PlaneShape(poi, sceneSettings, appSettings);
                break;
            case 'multiplane':
                //console.log(`🏭 ShapeFactory: Creating MultiPlaneShape`);
                createdShape = new MultiPlaneShape(poi, sceneSettings, appSettings);
                break;
            case 'torus':
                ////console.log(`🏭 ShapeFactory: Creating TorusShape`);
                createdShape = new TorusShape(poi, sceneSettings, appSettings);
                break;
            case 'youtube':
                //console.log(`🏭 ShapeFactory: Creating YoutubeShape`);
                createdShape = new YoutubeShape(poi, sceneSettings, appSettings);
                break;
            case 'triangle':
                ////console.log(`🏭 ShapeFactory: Creating TriangleShape`);
                createdShape = new TriangleShape(poi, sceneSettings, appSettings);
                break;
            case 'hexagon':
                ////console.log(`🏭 ShapeFactory: Creating HexagonShape`);
                createdShape = new HexagonShape(poi, sceneSettings, appSettings);
                break;
            case 'gltf':
                ////console.log(`🏭 ShapeFactory: Creating GLTFShape`);
                createdShape = new GLTFShape(poi, sceneSettings, appSettings);
                break;
            case 'usdz':
                //console.log(`🍎 ShapeFactory: Creating USDZShape for POI ${poi.name}`);
                //console.log(`🍎 ShapeFactory: POI URI: ${JSON.stringify(poi.poidata.uri.value)}`);
                //console.log(`🍎 ShapeFactory: POI shape: ${poi.poidata.shape.value}`);
                createdShape = new USDZShape(poi, sceneSettings, appSettings);
                //console.log(`🍎 ShapeFactory: USDZShape created successfully`);
                break;
            default:
                console.warn(`🏭 ShapeFactory: Unknown shape type: ${poi.poidata.shape.value}, falling back to BoxShape.`);
                createdShape = new BoxShape(poi, sceneSettings, appSettings);
                break;
        }

        ////console.log(`🏭 ShapeFactory: Created shape: ${createdShape?.constructor.name || 'null'}`);
        return createdShape;
    }
}